/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <div
    :style="[props.imageWidth?'--imageWidth:'+props.imageWidth+'px;':'',props.remarkWidth?'--remarkWidth:'+props.remarkWidth+'px;':''+props.backgroundColor?'--bgColor:'+props.backgroundColor+';':'',elCtlStyle]"
    :class="[props.labelPosition,props.remarkPosition?'remarkLeft':'']"
    v-if="vuex['showCtl']!==false"
    class="xmInput xmImgUpload">
    <xm-form-item v-if="showLabel" :props="props" :propKey="model.key"/>
    <div v-if="props.remark&&props.remarkPos==='top'" class="input-remark" :class="props.remarkPos">
    </div>
    <template v-if="props.readFileUrl">
      <xm-img-upload   :disabled="vuex['disabled']||props.readOnlyText===true||readOnlyText===true"
                       :value="pModelObj[model.key]"
                       :businessId="pModelObj[model.key]||getBusId"
                       :userUploadAction="props.userUploadAction"
                       :multiple="props.multiple"
                       :maxSize="props.fileSize"
                       :events="events"
                       :filetype="props.filetype"
                       @done="doneFile"
                       v-model:imgUrl="pModelObj[model.key]"
                       :selSystemImg="false"
      />
    </template>
    <template v-else>
      <xm-img-upload   :disabled="vuex['disabled']||props.readOnlyText===true||readOnlyText===true"
                       :userUploadAction="props.userUploadAction"
                       :businessId="pModelObj[model.key]||getBusId"
                       :multiple="props.multiple"
                       :maxSize="props.fileSize"
                       :filetype="props.filetype"
                       :events="events"
                       @done="doneFile"
                       v-model:busId="pModelObj[model.key]"
                       :selSystemImg="false"
      />
    </template>
    <el-remark :props="props"/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {
  },
  name: "xmImgUploadCtl",
});
</script>

<script lang="ts" setup>
import ElRemark from "@/main-page-form/common/el-remark.vue";
import XmFormItem from "@/main-page/commonVue/xm-form-item.vue";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useComElState} from "@/main-page/ctls/hooks/useComElState";
import XmImgUpload from "@/components/xmFileComCtl/xm-img-upload.vue";
import {GoingNewUtils} from "xmgoing-utils";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import {useFileUploadHook} from "@/main-page-form/ctls/fileCtls/hooks/useFileUploadHook";

const getBusId=computed(()=>{
  return "xmImgUpload_"+GoingNewUtils.getUUChar(20);
})

const pageModelsStore:any=usePageModelsStore();
interface propTypes{
  props:any,
  events:any,
  styles:any,
  dataSourceId:string,
  showLabel:boolean,
  model:any,
  readOnlyText:boolean,
  pItemFormKey:string,
  pModelObj:any,
  elConfig:any,
  pItem:string,
}
const propsPage=withDefaults(defineProps<propTypes>(),{
  dataSourceId:'',
  showLabel:true,
  pItem:'',
  styles:{},
  pItemFormKey:'',
  events:[],
  readOnlyText:false,
  props:{},
  pModelObj:{},
  model:{},
  elConfig:{}
});
const {pModelObj}:any=toRefs(propsPage);
const {elConfig, props, styles, model, events, dataSourceId, pItem,dataConfig}: any = propsPage;
const {vuex} = useVuexState({sectionConfig: props, vuexProps: ['showCtl', 'disabled', CtlComEnum.DEFAULT_SET]});
const {elCtlStyle, elBaseStyle, formElComClass, formElComSty} = useCtlStyle({
  styles,
  props,
  propsStyl: ['width'],
  outExtendProp: unref(pItem)==='xmForm'?['marginLeft','marginTop', 'marginRight', 'marginBottom', 'paddingLeft']:[]
});

useComElState({vuexState:vuex,elConfig,model, props, pModelObj});
const emits=defineEmits(['doneFile'])
const {doneFile}=useFileUploadHook({emits, props, events, pModelObj, model});


</script>

<style type="text/css" lang="less">

.xmImgUpload{
  .input-remark{
    font-size: 12px;
    color:#777;
    &.top{
      line-height: 33px;
      font-size: 14px;
    }
  }
}
.xmForm.readOnlyText{
  .ant-upload.ant-upload-select-picture-card{
    cursor: unset;
    display: none;
  }
}

</style>
